import { render } from "./userRecovery.vue?vue&type=template&id=6118a04c&scoped=true"
import script from "./userRecovery.vue?vue&type=script&lang=js"
export * from "./userRecovery.vue?vue&type=script&lang=js"

import "./userRecovery.vue?vue&type=style&index=0&id=6118a04c&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6118a04c"]])

export default __exports__